import { render } from "./FiltrosTarefas.vue?vue&type=template&id=2a7144c6"
import script from "./FiltrosTarefas.vue?vue&type=script&lang=js"
export * from "./FiltrosTarefas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__